const paymentMethods=[
    {"key":"stripe","zohoValue":"Stripe","incomeValue":"Stripe",type:"stripepayment"},
    {"key":"JCC","zohoValue":"JCC Smart","incomeValue":"JCC Smart",type:"jccpayment"},
    {"key":"alexis","zohoValue":"Cash","incomeValue":"Alexis Odysseos",type:"cashpayment"},
    {"key":"petros","zohoValue":"Cash","incomeValue":"Petros Zandis",type:"cashpayment"},
    {"key":"nicolas","zohoValue":"Cash","incomeValue":"Nicolas Stefanov",type:"cashpayment"},
    {"key":"stelios","zohoValue":"Cash","incomeValue":"Stelios Sfikouris",type:"cashpayment"},
    {"key":"bank","zohoValue":"Bank Transfer","incomeValue":"Bank",type:"cashpayment"}
];
export default paymentMethods;